<template>
  <div class="impressum-container">
    <h1>Impressum</h1>

    <p>Angaben gemäß § 5 TMG:</p>
    <p>
      Denys Seredenko & Julian Kirsch<br>
      Gottfried-Kiesow-Platz 2<br>
      02826 Görlitz
    </p>

    <h2>Vertreten durch:</h2>
    <p>Denys Seredenko & Julian Kirsch</p>

    <h2>Kontakt:</h2>
    <p>
      E-Mail: Denys.Seredenko@stud.hszg.de<br>
      E-Mail: Julian.Kirsch@stud.hszg.de
    </p>

    <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h2>
    <p>
      Denys Seredenko & Julian Kirsch<br>
      Gottfried-Kiesow-Platz 2<br>
      02826 Görlitz
    </p>

    <h2>Haftungsausschluss:</h2>
    <p>
      Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
      Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
    </p>
  </div>
</template>

<script>
export default {
  name: "Impressum"
};
</script>

<style scoped>
.impressum-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  background-color: #121212;
  color: #ddd;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

.impressum-container h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

.impressum-container h2 {
  font-size: 1.2em;
  margin-top: 1.5em;
  margin-bottom: 0.3em;
}

.impressum-container a {
  color: #0066cc;
  text-decoration: none;
}

.impressum-container a:hover {
  text-decoration: underline;
}

.quelle {
  font-size: 0.9em;
  margin-top: 2em;
  color: #666;
}
</style>
